import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { headers } from "./headers";

const useUpdateModelListData = () => {
  const updateModelListData = async (data) => {
    const baseURL = `${process.env.REACT_APP_API_ORIGIN}/v1/api/model_list/${data?.prd_ln}/${data?.id}`;
    return await axios.put(baseURL, data, { headers });
  };
  return useMutation({
    mutationFn: updateModelListData,
  });
};

export default useUpdateModelListData;
